export default __webpack_public_path__ + "static/flipSectionBg-ad8c3d5efb1b8108081e5e66fa9cb7ec.png";